var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfolio"},[_c('NavigationPanel',{on:{"newViewSelected":_vm.newViewSelected}}),(_vm.selectedView === 0)?_c('Introduction'):_vm._e(),(_vm.selectedView === 1)?_c('Resume'):_vm._e(),(_vm.selectedView === 2)?_c('Projects'):_vm._e(),(_vm.selectedView === 3)?_c('Skills'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }